var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5958 5.57635L8 3.00016H3C2.46957 3.00016 1.96086 3.21088 1.58579 3.58595C1.21071 3.96102 1 4.46973 1 5.00016V16.0002C1 16.5306 1.21071 17.0393 1.58579 17.4144C1.96086 17.7894 2.46957 18.0002 3 18.0002H14C14.5304 18.0002 15.0391 17.7894 15.4142 17.4144C15.7893 17.0393 16 16.5306 16 16.0002V11.0002L13.4147 8.41341M14.586 1.58616C14.7705 1.39514 14.9912 1.24278 15.2352 1.13796C15.4792 1.03314 15.7416 0.977969 16.0072 0.975661C16.2728 0.973354 16.5361 1.02396 16.7819 1.12452C17.0277 1.22508 17.251 1.37359 17.4388 1.56137C17.6266 1.74916 17.7751 1.97246 17.8756 2.21825C17.9762 2.46405 18.0268 2.72741 18.0245 2.99296C18.0222 3.25852 17.967 3.52096 17.8622 3.76497C17.7574 4.00898 17.605 4.22967 17.414 4.41416L8.828 13.0002H6V10.1722L14.586 1.58616Z",
    stroke: "#F66700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.adcf69f5022ea0331195877cb98bf7f6.svg";
export { ForwardRef as ReactComponent };